

















import mixins from 'vue-typed-mixins';
import AuthUtils from '@/utils/AuthUtils';
export default mixins().extend({
  computed: {
    roles() {
      return this.$session?.permissions
        .map((permission) => permission.role)
        .filter(
          (role, index, list) =>
            list.findIndex((val) => val.id === role.id) === index
        );
    },

    headers() {
      return [
        { text: 'name', value: 'name' },
        { text: 'type', value: 'type' },
      ];
    },
  },

  methods: {
    async select(role: any) {
      try {
        AuthUtils.set({ role: role });
        try {
          await this.$router.push({ name: 'dashboard' });
        } catch (error) {
          // doesn't matter
        }
      } catch (error) {
        console.error('error setting role', error);
      }
    },
  },
});
